import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APP_NAME, formatDocumentTitle } from "../config/siteBranding";
import { resolvePageTitle } from "../config/pageTitles";

const FAVICON_URL = `${process.env.PUBLIC_URL || ""}/favicon.png`;

function ensureFavicon(href) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/png";
  link.href = href;
}

function ensureAppleTouchIcon(href) {
  let link = document.querySelector("link[rel='apple-touch-icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "apple-touch-icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

export default function DocumentHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    ensureFavicon(FAVICON_URL);
    ensureAppleTouchIcon(FAVICON_URL);
  }, []);

  useEffect(() => {
    if (pathname.startsWith("/app/") || /^\/[^/]+\/dashboard$/.test(pathname)) {
      return;
    }

    const pageTitle = resolvePageTitle(pathname) || APP_NAME;
    document.title = formatDocumentTitle(pageTitle);
  }, [pathname]);

  return null;
}
